import { render, staticRenderFns } from "./OrganisationBookingTemplateList.vue?vue&type=template&id=6ba2bf92&"
import script from "./OrganisationBookingTemplateList.vue?vue&type=script&lang=js&"
export * from "./OrganisationBookingTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationBookingTemplateList.vue?vue&type=style&index=0&id=6ba2bf92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports